module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABQ0lEQVRoQ+3Y0QmDMBAG4EQX6AqdoLiBJYOUbuQI7qGIIzhCR3AA4xUfCiIt3l3O5oT47B/+786HoDUnf+zJ+5sEiL3BtIG0gcAJpE8ocIDB8bSBXyN0zlVZltVN0wyUMVNzh2zAOVdbax8AMHrvr33fjxgEJycO+JRYCs/z/Oy6rqaUp+ZEAf8uv2DFADHKiwFilRcBxCwfDIhdPgigoTwboKU8C6CpPBmgrTwJoLE8GqC1PAqgufwuoCzLS57nvbX2BgAv732BuVlyc5hL3/ad3bvQuowxZpim6U5FUHJUxC5gOVAzAgXQjEADtCJIAI0IMkAbggXQhGADtCCCABoQwYDYCBFATIQYIBZCFPAN0bZtgbnfbK8r2Jw4YI0AgAr7a5GbOwSAmbjUOwkgNUnuOWkD3MlJ5dIGpCbJPef0G3gDg078QPN4PLoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow2left.png
// module id = TPmi
// module chunks = 1